import * as axios from 'axios';
import Vue from "vue";

function translateField(txt) { 

    const data = { 
                   text: txt
                 }
  
    const url = `/checklist/translate`;
    return axios.post(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}


function getChecklists(lang) { 

    const data = {  lang: lang }
  
    const url = `/checklist/checklists`;
    return axios.get(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}


function getChecklist(lang, cl_uid) { 

  const data = {  }

  const url = `/checklist/setup/${cl_uid}`;
  return axios.get(url, data)
      // get data
      .then(x => x.data)
      // add url field
      .then(x => {
          if (x.status == 'error') {
              return Promise.reject(x);
          }
          return x
      });
}

function getAllComponents(cl_uid, lang) { 

    const data = {  }

    const url = `/checklist/components/${cl_uid}`;
    return axios.get(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}


function getMessageFormats(lang) { 

    const data = {  }

    const url = `/checklist/message-formats`;
    return axios.get(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}

function getComponent(cl_uid, comp_uid, level) { 

  const data = {  }

  console.log("getComponent")

  const url = `/checklist/component/${cl_uid}/${level}/${comp_uid}`;
  return axios.get(url, data)
      // get data
      .then(x => x.data)
      // add url field
      .then(x => {
          if (x.status == 'error') {
              return Promise.reject(x);
          }
          return x
      });
}


function getComponentByInspectUid(cl_uid, comp_uid) { 

    const data = {  }
  
    const url = `/checklist/component-inspect/${cl_uid}/${comp_uid}`;
    return axios.get(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}


function getTask(cl_uid, task_uid) { 

  const data = {  }

  const url = `/checklist/task/${cl_uid}/${task_uid}`;
  return axios.get(url, data)
      // get data
      .then(x => x.data)
      // add url field
      .then(x => {
          if (x.status == 'error') {
              return Promise.reject(x);
          }
          return x
      });
}

function getQuestion(cl_uid, question_uid) { 

  const data = {  }

  const url = `/checklist/question/${cl_uid}/${question_uid}`;
  return axios.get(url, data)
      // get data
      .then(x => x.data)
      // add url field
      .then(x => {
          if (x.status == 'error') {
              return Promise.reject(x);
          }
          return x
      });
}


function getAnswer(cl_uid, answer_uid) { 

  const data = {  }

  const url = `/checklist/answer/${cl_uid}/${answer_uid}`;
  return axios.get(url, data)
      // get data
      .then(x => x.data)
      // add url field
      .then(x => {
          if (x.status == 'error') {
              return Promise.reject(x);
          }
          return x
      });
}

function createItem(d) { 

  const data = {...d}

  const url = `/checklist/create-item`;
  return axios.post(url, data)
      // get data
      .then(x => x.data)
      // add url field
      .then(x => {
          if (x.status == 'error') {
              return Promise.reject(x);
          }
          return x
      });

}

function updateItem(d) {  

  const data = {...d}

  const url = `/checklist/update-item`;
  return axios.post(url, data)
      // get data
      .then(x => x.data)
      // add url field
      .then(x => {
          if (x.status == 'error') {
              return Promise.reject(x);
          }
          return x
      });

}


function duplicateItem(d) {  

    const data = {...d}
  
    const url = `/checklist/duplicate-item`;
    return axios.post(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}


function deleteItem(d) {  

    const data = {...d}
  
    const url = `/checklist/delete-item`;
    return axios.post(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}
  
function sortItems(items, entry) {  

    const data = { entry, items }

    const url = `/checklist/sort-items`; 
    return axios.post(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}

function createChecklist(d) { 

    const data = {...d}
  
    const url = `/checklist/create-checklist`;
    return axios.post(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
  
  }


  function deleteChecklist(d) { 

    const data = {...d}
  
    const url = `/checklist/delete-checklist`;
    return axios.post(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
  
  }


  function checklistPostReq(action, d) { 

    const data = {...d}
  
    const url = `/checklist/${action}`;
    return axios.post(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
  }


  function genPostReq(controller, action, d) { 

    const data = {...d}
  
    const url = `/${controller}/${action}`;
    return axios.post(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
  }


export {  getChecklist, 
          getAllComponents, 
          getComponent, 
          getComponentByInspectUid,
          getTask, 
          getQuestion, 
          createItem, 
          updateItem,
          getAnswer,
          duplicateItem,
          deleteItem,
          sortItems,
          getChecklists,
          createChecklist,
          deleteChecklist,
          translateField,
          checklistPostReq,
          getMessageFormats,
          genPostReq  }